import type { track as TrackFn } from "pro-features/components/WithTrack/src/WithTrack";

export default function createWebsitesTrackingService(track: TrackFn) {
    return {
        trackWidgetCtaClick: (widgetName: string, domain: string) => {
            track("website widgets", "click", `open tab/${widgetName}/${domain}`);
        },
        trackCompanyNameClick: (companyName: string, domain: string) => {
            track("website card", "click", `open company page/${companyName}/${domain}`);
        },
        trackCompanyAppClick: (appName: string, domain: string) => {
            track("website card", "click", `open app page/${appName}/${domain}`);
        },
    };
}
